import { render } from "./CustomerEditor.vue?vue&type=template&id=12c8e4dc&scoped=true"
import script from "./CustomerEditor.vue?vue&type=script&lang=js"
export * from "./CustomerEditor.vue?vue&type=script&lang=js"

import "./CustomerEditor.vue?vue&type=style&index=0&id=12c8e4dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c8e4dc"]])

export default __exports__